import Vue from 'vue';

Vue.component('profile-overview', {
    props: ['memberProfile', 'countries'],

    data() {
        return {
            dmpBalance: null,
            hasDmps: false,
        };
    },

    mounted() {
        this.getDmpBalance();
    },

    methods: {
        getDmpBalance() {
            this.$api.gms.member.getDmpBalance()
            .then((response) => {
                if (!response.data.success) {
                    throw response.data;
                }
                this.dmpBalance = response.data.result;

                if (this.dmpBalance.corporateDmp || this.dmpBalance.partnerDmp || this.dmpBalance.privateDmp || this.dmpBalance.parentDmp) {
                    this.hasDmps = true;
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
    },
});
